export const properties = {
    oktaRedirectUri: '/osar/msi',
    oktaRedirectUriImplict: '/osar/msi/implicit/callback',
    oktaRedirectUriConfirmation: '/erums/order/confirmation/implicit/callback',
    erumsRedirectCookieName: 'erums-from-uri',
    clientBannerHeader: 'banner',
    headerStoreId: '',
    headerFulfillment: 'instore',
    storeId: '',
    tooltips: {},
    bannerConfiguration: {
        tomthumb: {
            banner: 'Tom Thumb',
            logoUrls: {
                color: 'TomThumb_RGB.svg',
                white: 'TomThumb_W.svg'
            }
        },
        albertsons: {
            banner: 'Albertsons',
            logoUrls: {
                color: 'Albertsons_RGB.svg',
                white: 'Albertsons_W.svg'
            }
        },
        vons: {
            banner: 'Vons',
            logoUrls: {
                color: 'Vons_RGB.svg',
                white: 'Vons_W.svg'
            }
        },
        safeway: {
            banner: 'Safeway',
            logoUrls: {
                color: 'Safeway_RGB.svg',
                white: 'Safeway_W.svg'
            }
        },
        randalls: {
            banner: 'Randalls',
            logoUrls: {
                color: 'Randalls_RGB.svg',
                white: 'Randalls_W.svg'
            }
        },
        pavilions: {
            banner: 'Pavilions',
            logoUrls: {
                color: 'Pavilions_RGB.svg',
                white: 'Pavilions_W.svg'
            }
        },
        jewelosco: {
            banner: 'Jewel-Osco',
            logoUrls: {
                color: 'JewelOsco_Vert_Oval_RGB.svg',
                white: 'JewelOsco_Vert_Oval_W.svg'
            }
        },
        carrsqc: {
            banner: 'Carrs',
            logoUrls: {
                color: 'Carrs_RGB.svg',
                white: 'Carrs_W.svg'
            }
        },
        acmemarkets: {
            banner: 'ACME',
            logoUrls: {
                color: 'Acme_RGB.svg',
                white: 'Acme_W.svg'
            }
        },
        shaws: {
            banner: 'Shaws\'s',
            logoUrls: {
                color: 'Shaws_RGB.svg',
                white: 'Shaws_W.svg'
            }
        },
        starmarket: {
            banner: 'Star Market',
            logoUrls: {
                color: 'StarMarket_RGB.svg',
                white: 'StarMarket_W.svg'
            }
        },
        kingsfoodmarkets: {
            banner: 'Kings',
            logoUrls: {
                color: 'Kingsfoodmarkets_RGB.svg',
                white: 'Kingsfoodmarkets_W.svg'
            }
        },
        haggen: {
            banner: 'Haggen',
            logoUrls: {
                color: 'haggen_RGB.svg',
                white: 'haggen_W.svg'
            }
        },
        andronicos: {
            banner: 'Andronico\'s',
            logoUrls: {
                color: 'andronicos_RGB.svg',
                white: 'andronicos_W.svg'
            }
        },
        balduccis: {
            banner: 'Balducci\'s',
            logoUrls: {
                color: 'balduccis_RGB.svg',
                white: 'balduccis_W.svg'
            }
        },
        shopamigos: {
            banner: 'Amigo\'s',
            logoUrls: {
                color: 'amigos_RGB.svg',
                white: 'amigos_W.svg'
            }
        }
    },
    PromoTypeDescription: {
        BOGO: 'Buy 1 Get 1 Free',
        B2G1: 'Buy Two Get 1 Free'
    },
    timer: {
        lastLoginAllowedTime: 45
    },
    summaryTexts: {
        sumamrySnapText: 'SNAP Eligible Item Total',
        sumamryNonSnapText: 'Non-SNAP Eligible Item Total'
    },
    rewardsConfig: {
        bannerMapper: {
            safeway: 'SAFEWAY',
            vons: 'VONS',
            randalls: 'RANDALLS',
            tomthumb: 'TOMTHUMB',
            acmemarkets: 'ACMEMARKETS',
            carrsqc: 'CARRSQC',
            jewelosco: 'JEWELOSCO',
            albertsons: 'ALBERTSONS',
            starmarket: 'STARMARKET',
            shaws: 'SHAWS',
            pavilions: 'PAVILIONS',
            kingsfoodmarkets: 'KINGSFOODMARKETS',
            haggen: 'HAGGEN',
            andronicos: 'ANDRONICOS',
            balduccis: 'BALDUCCIS',
            shopamigos: 'SHOPAMIGOS',
        },
        displaybleBannerNames : {
            safeway: 'Safeway',
            vons: 'Vons',
            albertsons: 'Albertsons',
            shaws: 'Shaws',
            andronicos: 'Andronicos',
            jewelosco: 'Jewel-Osco',
            acmemarkets: 'Acme',
            starmarket: 'Star Market',
            carrsqc: 'Carrs',
            randalls: 'Randalls',
            tomthumb: 'Tom Thumb',
            pavilions: 'Pavilions',
            haggen: 'Haggen',
            kingsfoodmarkets: 'Kings Food Markets',
            balduccis: 'Balduccis',
            shopamigos: 'Amigos',
        },
        errorText: 'Sorry, we\'re having technical difficulties, please check back later.',
        noSubscriptionDefaultText: 'Shop Now',
        FULFILLMENT: 'FULFILLMENT',
        METHOD: 'METHOD',
        DELIVERY: 'DELIVERY',
        PICKUP: 'PICKUP',
        DUG: 'DUG',
        SHOP: 'SHOP',
        SLOT: 'SLOT',
        storeSearchSize: '10',
        radius: '50',
        expiredPaymentMethod: 'This card is expired',
        serviceErrorMessage: 'Apologies, our site is currently experiencing technical difficulties, please try again later.',
        addressErrorMessage: 'Sorry, This address is not available for Schedule & Save orders.',
        enableBirthdayModule: true,
        enableFuelStationModule: true,
        v2Enabled: true,
        disableEconReceiptURL: false,
        disableMulticlipRewardGallery: false,
        disableToastmessageRewardPage: false,
        imagePath: '//images.albertsons-media.com/is/image/ABS/',
        childList: "childList",
        cookiesOneTrustConsentEle: "onetrust-consent-sdk",
        partnerHub:{
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: true,
            albertsons: true,
            starmarket: true,
            shaws: true,
            pavilions: true,
            kingsfoodmarkets: true,
            haggen: true,
            andronicos: true,
            balduccis: true,
            shopamigos: true,
        },
        partnerLanding:{
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: true,
            albertsons: true,
            starmarket: true,
            shaws: true,
            pavilions: true,
            kingsfoodmarkets: true,
            haggen: true,
            andronicos: true,
            balduccis: true,
            shopamigos: true,
        },
        fuelSiteBanner: {
            safeway: true,
            vons: true,
            randalls: true,
            tomthumb: true,
            acmemarkets: true,
            carrsqc: true,
            jewelosco: false,
            albertsons: true,
            starmarket: false,
            shaws: false,
            pavilions: true,
            kingsfoodmarkets: false,
            haggen: true,
            andronicos: true,
            balduccis: false,
            shopamigos: false,
        },
        freshpassRebranding: {
            safeway: false,
            vons: false,
            randalls: false,
            tomthumb: false,
            acmemarkets: false,
            carrsqc: false,
            jewelosco: false,
            albertsons: false,
            starmarket: false,
            shaws: false,
            pavilions: false,
            kingsfoodmarkets: false,
            haggen: false,
            andronicos: false,
            balduccis: false
        },
        nonFreshpassBanners: ['haggen','andronicos'],
        expediaTerms: 'https://www.forutravel.com/legal/terms',
        expediaPrivacy: 'https://www.forutravel.com/legal/privacy',
        experimentData: 'https://legal.expediagroup.com/privacy/privacy-and-cookies-statements/partner-sites1/expedia-partner-solutions1?field_b2ccountry_target_id=139&field_b2clanguage_target_id=33'
    }
};
